"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _TimelineRequestElevatedEmailPermissionsCard = _interopRequireDefault(require("crm_ui/timeline/components/events/TimelineRequestElevatedEmailPermissionsCard"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _generalStore = require("general-store");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _HasEmailEngagementsStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/HasEmailEngagementsStore"));

var _immutable = require("immutable");

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var dependencyProps = {
  subject: _SubjectType.default.isRequired
};
var propTypes = (0, _extends2.default)({
  hasEmailEngagements: _propTypes.default.bool
}, dependencyProps);
var dependencies = {
  hasEmailEngagements: {
    stores: [_HasEmailEngagementsStore.default],
    deref: function deref(_ref) {
      var subject = _ref.subject;
      var subjectId = (0, _ImmutableModel.getId)(subject);
      var objectType = (0, _ImmutableModel.getObjectType)(subject);

      if (!subjectId || !objectType || _ScopesContainer.default.isScoped('connected-email-data-access')) {
        return null;
      }

      return _HasEmailEngagementsStore.default.get((0, _immutable.Map)({
        subjectId: "" + subjectId,
        objectType: objectType
      }));
    }
  }
};

var TimelineRequestElevatedEmailPermissionsCardWrapper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TimelineRequestElevatedEmailPermissionsCardWrapper, _Component);

  function TimelineRequestElevatedEmailPermissionsCardWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineRequestElevatedEmailPermissionsCardWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineRequestElevatedEmailPermissionsCardWrapper).call(this));
    _this.state = {
      portal: null,
      currentUser: null
    };
    return _this;
  }

  (0, _createClass2.default)(TimelineRequestElevatedEmailPermissionsCardWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      (0, _userInfo.default)().then(function (_ref2) {
        var portal = _ref2.portal,
            user = _ref2.user;

        if (!_this2._isMounted) {
          return;
        }

        _this2.setState({
          portal: portal,
          currentUser: user
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "shouldRenderEmailJITACard",
    value: function shouldRenderEmailJITACard() {
      var isAllowedToViewEmailsOnTimeline = _ScopesContainer.default.isScoped('connected-email-data-access');

      if (isAllowedToViewEmailsOnTimeline || !this.state.portal || !this.state.currentUser || !this.props.hasEmailEngagements) {
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.shouldRenderEmailJITACard()) {
        return null;
      }

      return _react.default.createElement(_UICardWrapper.default, {
        className: "m-top-3"
      }, _react.default.createElement(_TimelineRequestElevatedEmailPermissionsCard.default, {
        currentUserEmail: this.state.currentUser.email,
        portalDomain: this.state.portal.domain
      }));
    }
  }]);
  return TimelineRequestElevatedEmailPermissionsCardWrapper;
}(_react.Component);

TimelineRequestElevatedEmailPermissionsCardWrapper.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(TimelineRequestElevatedEmailPermissionsCardWrapper);

exports.default = _default;
module.exports = exports.default;